import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  FilesTitle,
  ImagesContainer,
  ImageText,
} from "../../assets/styles/views/Steps";
import { Button } from "../../components/Button";
import ImagePDF from "../../assets/images/pdf.png";
import ImageXML from "../../assets/images/xml.png";

import { useInvoice } from "store/context";

const StepThree = () => {
  const navigate = useNavigate()
  const { state: {invoice} } = useInvoice();
  return (
    <Container>
      <FilesTitle>¡Se han creado los archivos exitosamente!</FilesTitle>
      <ImagesContainer>
        <div>
          <img src={ImageXML} alt="xml icono" />
          <ImageText href={invoice.cfdiUrl} target="_blank">Descargar</ImageText>
          
        </div>
        <div>
          <img src={ImagePDF} alt="pdf icono" />
          <ImageText href={invoice.pdfUrl} target="_blank">Descargar</ImageText>
          
        </div>
      </ImagesContainer>

      <div style={{ padding: '100px 70px' }}>
        <Button onClick={() => navigate('/')}>PAGINA INICIO</Button>
      </div>
    </Container>
  );
};

export default StepThree;
